import { ResponsiveContainer } from "recharts";

const loanTypes = [
  "SALARYADVANCE-ONEMONTH",
  "MicroLoan",
  "STAFFLOAN",
  "AssetFinance",
  "SalariedLoan",
  "InsurancePremiumFinancing",
  "AgribusinessLoan",
  "LandlordLoan",
  "TradeFinanceProducts",
];

const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const getColor = (value) => {
  if (value >= 25) return "#800026";
  if (value >= 22.5) return "#BD0026";
  if (value >= 20) return "#E31A1C";
  if (value >= 17.5) return "#FC4E2A";
  if (value >= 15) return "#FD8D3C";
  if (value >= 12.5) return "#FEB24C";
  if (value >= 10) return "#FED976";
  if (value >= 7.5) return "#FFEDA0";
  return "#FFFFCC";
};

const legendTicks = [25, 22.5, 20, 17.5, 15, 12.5, 10, 7.5, 5.0];

// Helper to abbreviate loan type names
const abbreviateLoanType = (name) => {
  // Use known abbreviations or first letters
  const map = {
    "SALARYADVANCE-ONEMONTH": "SA-1M",
    MicroLoan: "Micro",
    STAFFLOAN: "Staff",
    AssetFinance: "Asset",
    SalariedLoan: "Salary",
    InsurancePremiumFinancing: "Ins.",
    AgribusinessLoan: "Agri",
    LandlordLoan: "Land",
    TradeFinanceProducts: "Trade",
  };
  return map[name] || name.slice(0, 5);
};

const HeatmapChart = ({ loanDefaultStatistics }) => {
  const data = loanDefaultStatistics || [];

  const cellWidth = 50;
  const cellHeight = 50;
  const chartWidth = loanTypes.length * cellWidth + 100;
  const chartHeight = months.length * cellHeight + 100;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
      }}
    >
      {/* Heatmap grid */}
      <ResponsiveContainer width={chartWidth} height={chartHeight}>
        <svg>
          {/* Draw cells */}
          {months.map((m, row) =>
            loanTypes.map((l, col) => {
              const value = data[row]?.[l] || 0;
              return (
                <g key={`${m}-${l}`}>
                  <rect
                    x={col * cellWidth + 60}
                    y={row * cellHeight + 40}
                    width={cellWidth}
                    height={cellHeight}
                    fill={getColor(value)}
                    stroke="#fff"
                  />
                  <text
                    x={col * cellWidth + 60 + cellWidth / 2}
                    y={row * cellHeight + 40 + cellHeight / 2 + 5}
                    textAnchor="middle"
                    fontSize="16"
                    fill="#000"
                  >
                    {value}
                  </text>
                </g>
              );
            })
          )}

          {/* X Axis labels with abbreviations */}
          {loanTypes.map((l, col) => (
            <text
              key={l}
              x={col * cellWidth + 60 + cellWidth / 2}
              y={months.length * cellHeight + 60}
              textAnchor="middle"
              fontSize="12"
            >
              {abbreviateLoanType(l)}
            </text>
          ))}

          {/* X Axis title */}
          <text
            x={(loanTypes.length * cellWidth) / 2 + 60}
            y={months.length * cellHeight + 80}
            textAnchor="middle"
            fontSize="12"
            fontWeight="normal"
          >
            Loan Type
          </text>

          {/* Y Axis labels (Months) */}
          {months.map((m, row) => (
            <text
              key={m}
              x={50}
              y={row * cellHeight + 40 + cellHeight / 2 + 5}
              textAnchor="end"
              fontSize="12"
            >
              {m}
            </text>
          ))}

          {/* Y Axis title */}
          <text
            x={20}
            y={chartHeight / 2}
            textAnchor="middle"
            fontSize="12"
            fontWeight="normal"
            transform={`rotate(-90, 20, ${chartHeight / 2})`}
          >
            Months
          </text>

          {/* Chart title */}
          <text
            x={(loanTypes.length * cellWidth) / 2 + 60}
            y={30}
            textAnchor="middle"
            fontSize="14"
            fontWeight="normal"
          >
            Loan Default Count Heatmap by Loan Type
          </text>
        </svg>
      </ResponsiveContainer>

      {/* Legend */}
      <div
        style={{
          height: months.length * cellHeight,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          paddingRight: "8px",
          marginBottom: "20px",
        }}
      >
        {/* Gradient bar */}
        <div
          style={{
            height: months.length * cellHeight,
            width: "20px",
            background:
              "linear-gradient(to top, #FFFFCC, #FFEDA0, #FED976, #FEB24C, #FD8D3C, #FC4E2A, #E31A1C, #BD0026, #800026)",
            border: "1px solid #ccc",
          }}
        />

        {/* Tick labels */}
        <div
          style={{
            height: months.length * cellHeight,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            fontSize: "12px",
            marginLeft: "4px",
          }}
        >
          {legendTicks.map((tick, i) => (
            <span key={i}>{tick}</span>
          ))}
        </div>

        {/* Vertical label */}
        <div
          style={{
            position: "absolute",
            right: 0,
            top: "65%",
            left: "95%",
            transform: "translateY(-50%) rotate(-90deg)",
            transformOrigin: "center",
            fontSize: "12px",
            fontWeight: "normal",
            whiteSpace: "nowrap",
            color: "#000",
          }}
        >
          Loan Default Count
        </div>
      </div>
    </div>
  );
};

export default HeatmapChart;
